import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, mergeMap, of, switchMap, withLatestFrom } from 'rxjs';
import { TscAdminActions, TscAdminReducer, TscAdminSelectors } from '.';
import { TscAdminService } from '../services/admin.service';

@Injectable()
export class TscEmployeeEffects {
  private store = inject<Store<TscAdminReducer.TscAdminState>>(Store);
  private actions$ = inject(Actions);
  apiService = inject(TscAdminService);

  getEmployees$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TscAdminActions.GET_EMPLOYEES),
      map((action: TscAdminActions.GetEmployees) => action.payload),
      switchMap(payload =>
        this.apiService.loadEmployees(payload).pipe(
          map(employees =>
            employees.error ? new TscAdminActions.GetEmployeesFailure(employees.error) : new TscAdminActions.GetEmployeesSuccess(employees as any)
          ), // TODO To Sto
          catchError(error => of(new TscAdminActions.GetEmployeesFailure(error)))
        )
      )
    )
  );

  getEmployee$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TscAdminActions.GET_EMPLOYEE),
      map((action: TscAdminActions.GetEmployee) => action.payload),
      mergeMap(payload =>
        of(payload).pipe(
          withLatestFrom(this.store.select(TscAdminSelectors.getEmployeeById(payload.userId))),
          switchMap(([actionPayload, storeDataSet]) => {
            if (actionPayload?.force || !storeDataSet) {
              return this.apiService.getEmployee(payload.userId).pipe(
                map(response =>
                  response.error ? new TscAdminActions.GetEmployeeFailure(response.error) : new TscAdminActions.GetEmployeeSuccess(response)
                ),
                catchError(error => of(new TscAdminActions.GetEmployeeFailure(error)))
              );
            }
            return of(new TscAdminActions.GetEmployeeCached());
          })
        )
      )
    )
  );

  updateEmployee$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TscAdminActions.UPDATE_EMPLOYEE),
      map((action: TscAdminActions.UpdateEmployee) => action.payload),
      mergeMap(payload =>
        this.apiService.updateEmployee(payload).pipe(
          switchMap(response =>
            response.error
              ? [new TscAdminActions.UpdateEmployeeFailure(response.error, payload)]
              : [
                  new TscAdminActions.UpdateEmployeeSuccess(response, payload),
                  new TscAdminActions.GetEmployee({ userId: payload.aggregateId, force: true }),
                ]
          ),
          catchError(error => of(new TscAdminActions.UpdateEmployeeFailure(error, payload)))
        )
      )
    )
  );
}
